"use strict";

exports.__esModule = true;
exports.createWizard = createWizard;
var React = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactIntl = require("react-intl");
var _excluded = ["onSubmit", "initialValues", "children"],
  _excluded2 = ["nextStepIcon", "nextStepText", "lastStepIcon", "lastStepText"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Create components for a form wizard, based on the given configuration.
 * @component
 */
function createWizard(config) {
  var Context = /*#__PURE__*/React.createContext(undefined);
  var Form = /*#__PURE__*/function (_React$Component) {
    function Form() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.state = {
        stepIndex: 0,
        values: _this.props.initialValues,
        checkIfReportWithProvidedNameExist: _this.props.checkIfReportWithProvidedNameExist
      };
      _this.handleSubmit = function (values) {
        var steps = config.steps;
        var stepIndex = _this.state.stepIndex;
        var isLastStep = stepIndex === steps.length - 1;
        if (isLastStep) {
          return _this.props.onSubmit(values);
        }
        _this.setState({
          stepIndex: stepIndex + 1,
          values: values
        });
      };
      _this.validate = function (values) {
        var steps = config.steps;
        var stepIndex = _this.state.stepIndex;
        var step = steps[stepIndex];
        return step.validate ? step.validate(values) : {};
      };
      _this.goBack = function () {
        var stepIndex = _this.state.stepIndex;
        if (stepIndex > 0) {
          _this.setState({
            stepIndex: stepIndex - 1
          });
        }
      };
      _this.goForward = function () {
        var stepIndex = _this.state.stepIndex;
        var steps = config.steps;
        if (stepIndex < steps.length - 1) {
          _this.setState({
            stepIndex: stepIndex + 1
          });
        }
      };
      return _this;
    }
    _inheritsLoose(Form, _React$Component);
    var _proto = Form.prototype;
    _proto.render = function render() {
      var _this2 = this;
      var _this$props = this.props,
        _onSubmit = _this$props.onSubmit,
        _initialValues = _this$props.initialValues,
        children = _this$props.children,
        extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
      var steps = config.steps;
      var _this$state = this.state,
        stepIndex = _this$state.stepIndex,
        values = _this$state.values,
        checkIfReportWithProvidedNameExist = _this$state.checkIfReportWithProvidedNameExist;
      var step = steps[stepIndex];
      return /*#__PURE__*/React.createElement(_reactFinalForm.Form, {
        initialValues: values,
        onSubmit: this.handleSubmit,
        validate: this.validate
      }, function (_ref) {
        var handleSubmit = _ref.handleSubmit,
          valid = _ref.valid,
          submitting = _ref.submitting,
          form = _ref.form;
        var goForward = _this2.goForward,
          goBack = _this2.goBack;
        var isFirstStep = stepIndex === 0;
        var isLastStep = stepIndex === steps.length - 1;
        var canGoBack = !isFirstStep;
        var canGoForward = !isLastStep;
        var value = {
          form: form,
          stepIndex: stepIndex,
          step: step,
          isFirstStep: isFirstStep,
          isLastStep: isLastStep,
          canGoForward: canGoForward,
          canGoBack: canGoBack,
          goForward: goForward,
          goBack: goBack,
          valid: valid,
          submitting: submitting,
          checkIfReportWithProvidedNameExist: checkIfReportWithProvidedNameExist
        };
        return /*#__PURE__*/React.createElement("form", _extends({
          "data-testid": "WizardForm",
          onSubmit: function onSubmit(event) {
            // Debounced inputs (react-debounce-input) may not have flushed
            // into Final Form yet when Enter submits the wizard. Blur first
            // so forceNotifyOnBlur commits the value before submit reads it.
            // React 18 event batching made this race show up reliably in Cypress
            // (stuck on step 1; #field-reportKind never appears).
            var active = document.activeElement;
            if (active && active !== document.body && typeof active.blur === "function") {
              active.blur();
            }
            return handleSubmit(event);
          }
        }, extra), /*#__PURE__*/React.createElement(Context.Provider, {
          value: value
        }, children));
      });
    };
    return Form;
  }(React.Component);
  var CurrentStep = function CurrentStep(stepProps) {
    return /*#__PURE__*/React.createElement(Context.Consumer, null, function (controller) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: controller.stepIndex
      }, controller.step.render(Object.assign({}, controller, {
        stepProps: stepProps
      })));
    });
  };
  var BackButton = function BackButton(buttonProps) {
    return /*#__PURE__*/React.createElement(Context.Consumer, null, function (controller) {
      return /*#__PURE__*/React.createElement(_core.Button, _extends({
        "data-testid": "WizardBackButton",
        icon: _icons.IconNames.STEP_BACKWARD,
        onClick: controller.goBack,
        text: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
          id: "createWizard.BackButton.text",
          defaultMessage: "Back"
        }),
        disabled: !controller.canGoBack
      }, buttonProps));
    });
  };
  var SubmitButton = function SubmitButton(_ref2) {
    var nextStepIcon = _ref2.nextStepIcon,
      nextStepText = _ref2.nextStepText,
      lastStepIcon = _ref2.lastStepIcon,
      lastStepText = _ref2.lastStepText,
      extra = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement(Context.Consumer, null, function (controller) {
      return /*#__PURE__*/React.createElement(_core.Button, _extends({
        "data-testid": "WizardSubmitButton",
        icon: controller.isLastStep ? lastStepIcon || _icons.IconNames.FLOPPY_DISK : nextStepIcon || _icons.IconNames.STEP_FORWARD,
        type: "submit",
        intent: _core.Intent.PRIMARY,
        text: controller.isLastStep ? lastStepText || /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
          id: "createWizard.SubmitButton.saveText",
          defaultMessage: "Save"
        }) : nextStepText || /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
          id: "createWizard.SubmitButton.nextText",
          defaultMessage: "Next"
        }),
        disabled: !controller.valid
      }, extra));
    });
  };
  return {
    Form: Form,
    Consumer: Context.Consumer,
    CurrentStep: CurrentStep,
    BackButton: BackButton,
    SubmitButton: SubmitButton
  };
}